import { Size } from 'ol/size';

/**
 * Gets the padding to display the search results (avoids to hide search results
 * behind the search results display)
 * @param size The viewport size
 * @returns The padding./util/sleep
 */
export const getPadding = (size?: Size) => {
  if (size && size[0] >= 768) {
    return [30, 30, 30, 395]; // top, right, bottom, left
  } else {
    return [54, 0, 0, 0]; // to do has to specified in detail
  }
};
